﻿import appModule from "../../app.module";

appModule.controller("EstimatesController", function() {
  var vm = this

  vm.$onInit = onInit;

  function onInit() {
    vm.deleted = location.hash.indexOf('/deleted') > -1
  }
});

